import React from 'react';

const ParticipantFilter = ({ filterValue, handleFilterChange }) => (
  <div className="participants-filter">
    <input
      className="participant-search-input"
      id="filter-id"
      name="participant-filter"
      placeholder="Search for People"
      type="text"
      value={filterValue}
      onChange={(e) => handleFilterChange(e)}
    />
  </div>
);

export default ParticipantFilter;